import { Injectable } from '@angular/core';
import { CustomBaseStore } from '@city/const';
import { BaseStoreFacade } from '@city/data-access';
import { CustomOrder } from '@order/const';
import { take } from 'rxjs/operators';
import { AnalyticsService } from './analytics.service';

@Injectable({ providedIn: 'root' })
export class CheckoutAnalyticsService {
  constructor(
    private analyticsService: AnalyticsService,
    private baseStoreFacade: BaseStoreFacade,
  ) {}

  onConfirmOrder(order: CustomOrder): void {
    // Тестовые заказы не отправляем
    if (!order.code || /-PERF-/.test(order.code)) {
      return;
    }

    this.baseStoreFacade
      .getActiveBaseStore()
      .pipe(take(1))
      .subscribe((baseStore: CustomBaseStore | undefined) => {
        this.analyticsService.sendEcommerceEvent({
          event: 'order_confirm',
          city: baseStore?.name,
        });
      });
  }

  alertNeedDeliveryAdress(): void {
    this.baseStoreFacade
      .getActiveBaseStore()
      .pipe(take(1))
      .subscribe((baseStore: CustomBaseStore | undefined) => {
        this.analyticsService.sendEcommerceEvent({
          event: 'Alert - Добавить адрес доставки',
          city: baseStore?.name,
        });
      });
  }

  alertNeedPickupAdress(): void {
    this.baseStoreFacade
      .getActiveBaseStore()
      .pipe(take(1))
      .subscribe((baseStore: CustomBaseStore | undefined) => {
        this.analyticsService.sendEcommerceEvent({
          event: 'Alert - Добавить магазин самовывоза',
          city: baseStore?.name,
        });
      });
  }

  alertNeedPaymentMode(): void {
    this.baseStoreFacade
      .getActiveBaseStore()
      .pipe(take(1))
      .subscribe((baseStore: CustomBaseStore | undefined) => {
        this.analyticsService.sendEcommerceEvent({
          event: 'Alert - Выбрать способ оплаты',
          city: baseStore?.name,
        });
      });
  }

  alertNeedDeliveryDate(): void {
    this.baseStoreFacade
      .getActiveBaseStore()
      .pipe(take(1))
      .subscribe((baseStore: CustomBaseStore | undefined) => {
        this.analyticsService.sendEcommerceEvent({
          event: 'Alert - Выбрать дату в время доставки',
          city: baseStore?.name,
        });
      });
  }
}
